import type { KidDetails } from '../model/interfaces'

import { useCommonStore } from '@shared/model'
import { runApiGet } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

import { useKidStore } from '../model/store'

interface KidDetailsApiOptions {
  kidId: string | number
  /** Defaults to the page loader; a modal that waits for the refresh passes its own. */
  onLoadingChange?: (loading: boolean) => void
}

/** `GET /admin-api/kids/{kid}/details` — the kid page: edit form, customer and disciplines with counters. */
export const useKidDetailsApi = async (options: KidDetailsApiOptions): Promise<KidDetails | null> => {
  const kidStore = useKidStore()
  const commonStore = useCommonStore()

  return runApiGet<KidDetails>(useAdminRoutes('admin.kid.details', { kid_id: options.kidId }), {
    setLoading: options.onLoadingChange ?? commonStore.setLoading,
    handle: (response) => {
      const kid: KidDetails = response.data
      kidStore.setKid(kid)
      return kid
    },
  })
}
